export default (t) => [
  {
    text: t('Bill No.'),
    value: 'bill_no',
    sortable: false,
    width: 200,
    togglable: true
  },
  {
    text: t('Branch'),
    value: 'branch',
    sortable: false,
    width: 140,
    togglable: true
  },
  {
    text: t('Source'),
    value: 'source',
    sortable: false,
    width: 130,
    togglable: true
  },
  {
    text: t('Table / Customer'),
    value: 'ref',
    sortable: false,
    width: 200,
    togglable: true
  },
  {
    text: t('Opened At'),
    value: 'created_at',
    sortable: true,
    width: 160,
    togglable: true
  },
  {
    text: t('Closed At'),
    value: 'closed_at',
    sortable: true,
    width: 160,
    togglable: true
  },
  {
    text: t('Status'),
    value: 'payment_status',
    sortable: false,
    width: 160,
    togglable: true
  },
  {
    text: t('Total'),
    value: 'total',
    sortable: false,
    width: 130,
    togglable: true
  },
  {
    text: t('Tax Invoice'),
    value: 'tax_invoice',
    sortable: false,
    width: 200,
    togglable: true
  },
  {
    text: t('Action'),
    value: 'action',
    sortable: false,
    width: 110
  }
];
